import React, { useState } from 'react';
import YouTube from 'react-youtube';

import useAuth from '~/hooks/useAuth';
import proBridge from '~/utils/pro-bridge';
import apiCall, { LIVE_URL } from '~/utils/apiCall';
import BG from '~/components/background';
import top from './images/top.png';
import bottom from './images/bottom.png';
import contents from './images/contents.png';
import check from './images/check_pink.png';
import quiz1_1 from './images/quiz1_1.png';
import quiz1_2 from './images/quiz1_2.png';
import quiz1_3 from './images/quiz1_3.png';

import quiz2_1 from './images/quiz2_1.png';
import quiz2_2 from './images/quiz2_2.png';
import quiz2_3 from './images/quiz2_3.png';
import quiz2_4 from './images/quiz2_4.png';
import quiz2_5 from './images/quiz2_5.png';

import submit from './images/submit.png';

import dview from './images/3dview.gif';
import vr from './images/360vr.gif';
import sign from './images/sign.png';

import { Wrap, TopWrap, Contents, Quiz1Wrap, Quiz2Wrap, Label, Checkbox } from './styled';

function CheckComponent({ imgUrl, isChecked, width, onClick }) {
  return (
    <div className="check" onClick={onClick}>
      <img style={{ width: width + '%' }} className="checkLabel" alt="" src={imgUrl} />
      {isChecked && <img alt="" className="checkImg" src={check} />}
    </div>
  )
}

export default function Main() {
  const { authKey } = useAuth();
  const [isEnd, setEnd] = useState(false);
  const [agree1, setAgree1] = useState(false);
  const [isComplete, setComplete] = useState(false);
  const [quiz1, setQuiz1] = useState(0);
  const [quiz2, setQuiz2] = useState(0);
  const [desc, setDesc] = useState('');

  function onClickQuiz1(answer) {
    setQuiz1(answer);
  }

  function onClickQuiz2(answer) {
    setQuiz2(answer);

    setDesc('');
  }

  function changeDesc(e) {
    const { value } = e.currentTarget;

    setDesc(value);
  }

  async function onClickSubmit() {
    if (isComplete) return alert('이미 참여한 이벤트입니다.');
    if (!isEnd) return alert('유튜브 영상 시청 후 정답제출해주세요.');
    if (!agree1) return alert('개인정보 수집/이용 에 대한 동의를 체크 해주세요.');
    if (quiz1 === 0) return alert('퀴즈1 정답을 체크 해주세요.');
    if (quiz2 === 0) return alert('퀴즈2 정답을 체크 해주세요.');
    if (quiz2 === 5 && desc.length < 10) return alert('기타 의견을 10자 이상 입력해주세요.');

    try {
      const res = await apiCall.post(`${LIVE_URL}/api/v1/pro/event/2022/02/tvc`, { 
        authKey,
        q1: quiz1,
        q2: quiz2,
        message: quiz2 === 5 ? desc : null,
       });
      const errorCode = [502, 503, 504, 505, 506];

      if (res?.code === 200) {
        setComplete(true);
        alert('이벤트 참여완료!');

        proBridge.android(call => {
          call.finishActivity();
        });
    
        proBridge.ios(call => {
          call.callHandler('iOS Echo', {
            cmd: 'finishActivity',
          });
        });

        return;
      } else if (res?.code === 501) {
        alert(res?.msg);
        proBridge.ios(call => {
          call.callHandler('iOS Echo', {
            cmd: 'showLoginAndReload',
          });
        });
    
        proBridge.android(call => {
          console.log('android');
          call.showLoginAndReload();
        });

        return;
      }

      if (errorCode.includes(res?.code)) return alert(res?.msg);
    } catch(err) {
      console.log(err);
      alert(err?.msg ?? '서버에러가 발생했습니다.');
    }
  }

  return (
    <Wrap>
      <TopWrap>
        <BG width={710} height={2666} imgUrl={top} />
        <div className="youtube">
          <YouTube videoId="LBx8rNVQo1o" onPlay={() => setEnd(true)} />
        </div>
      </TopWrap>

      <Contents>
        <BG width={710} height={1509} imgUrl={contents} />

        <Label>
          <Checkbox type="checkbox" checked={agree1} onChange={() => {setAgree1(prev => !prev);}} />
          <p>개인정보 수집/이용 에 대한 동의</p>
        </Label>

        <Quiz1Wrap>
          <div onClick={() => onClickQuiz1(1)}>
            <img alt="" src={dview} />
            <CheckComponent width={80} imgUrl={quiz1_1} isChecked={quiz1 === 1} />
          </div>
          <div onClick={() => onClickQuiz1(2)}>
            <img alt="" src={vr} />
            <CheckComponent width={80} imgUrl={quiz1_2} isChecked={quiz1 === 2}/>
          </div>
          <div onClick={() => onClickQuiz1(3)}>
            <img alt="" src={sign} />
            <CheckComponent width={80} imgUrl={quiz1_3} isChecked={quiz1 === 3}/>
          </div>
        </Quiz1Wrap>

        <Quiz2Wrap>
          <CheckComponent onClick={() => onClickQuiz2(1)} width={96} imgUrl={quiz2_1} isChecked={quiz2 === 1}/>
          <CheckComponent onClick={() => onClickQuiz2(2)} width={96} imgUrl={quiz2_2} isChecked={quiz2 === 2}/>
          <CheckComponent onClick={() => onClickQuiz2(3)} width={96} imgUrl={quiz2_3} isChecked={quiz2 === 3}/>
          <CheckComponent onClick={() => onClickQuiz2(4)} width={96} imgUrl={quiz2_4} isChecked={quiz2 === 4}/>
          <CheckComponent onClick={() => onClickQuiz2(5)} width={96} imgUrl={quiz2_5} isChecked={quiz2 === 5}/>

          <textarea disabled={quiz2 !== 5} rows={4} value={desc} onChange={changeDesc} placeholder="최소 10자 이상을 입력해주세요." />
        </Quiz2Wrap>

        <img className="submit" src={submit} onClick={onClickSubmit} />
      </Contents>

      <BG width={710} height={572} imgUrl={bottom}/>
    </Wrap>
  );
}